<template>
  <el-dialog
    :title="$t('communityRecommend.edit')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose">
    <el-form 
      :model="editCommunityRecommendInfo" 
      ref="editForm" 
      label-width="120px"
      :rules="rules">
      <el-form-item 
        :label="$t('communityRecommend.logo')" 
        prop="logo">
        <upload-image-url
          ref="uploadImage"
          :callBackListener="'editCommunityRecommend'"
          :callBackFunction="'notifyUploadCoverImage'"
          :imageCount="1">
        </upload-image-url>
      </el-form-item>
      <el-form-item 
        :label="$t('communityRecommend.productName')" 
        prop="prodName">
        <el-input 
          v-model="editCommunityRecommendInfo.prodName"
          :placeholder="$t('communityRecommend.requiredProductName')">
        </el-input>
      </el-form-item>
      <el-form-item 
        :label="$t('communityRecommend.price')" 
        prop="price">
        <el-input 
          v-model="editCommunityRecommendInfo.price"
          :placeholder="$t('communityRecommend.requiredPrice')">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editCommunityRecommend">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateCommunityRecommend } from '@/api/phone/communityRecommend/communityRecommendApi'
import UploadImageUrl from '@/components/system/UploadImageUrl'

export default {
  name: 'EditCommunityRecommend',
  components: {
    UploadImageUrl
  },
  data() {
    return {
      dialogVisible: false,
      editCommunityRecommendInfo: {
        crId: '',
        communityName: '',
        shopName: '',
        recommendType: '',
        logo: '',
        prodName: '',
        price: '',
        url: ''
      },
      rules: {
        logo: [
          { required: true, message: this.$t('communityRecommend.logoRequired'), trigger: 'blur' },
          { max: 512, message: this.$t('communityRecommend.max512Chars'), trigger: 'blur' }
        ],
        prodName: [
          { required: true, message: this.$t('communityRecommend.productNameRequired'), trigger: 'blur' },
          { max: 256, message: this.$t('communityRecommend.max256Chars'), trigger: 'blur' }
        ],
        price: [
          { required: true, message: this.$t('communityRecommend.priceRequired'), trigger: 'blur' },
          { max: 10, message: this.$t('communityRecommend.max10Chars'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(params) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.editForm.resetFields()
        Object.assign(this.editCommunityRecommendInfo, params)
        this.$refs.uploadImage.notifyPhotos([params.logo])
      })
    },
    handleClose() {
      this.$refs.editForm.resetFields()
      this.refreshEditCommunityRecommendInfo()
    },
    async editCommunityRecommend() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          try {
            await updateCommunityRecommend(this.editCommunityRecommendInfo)
            this.$message.success(this.$t('common.saveSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error('更新失败:', error)
          }
        }
      })
    },
    refreshEditCommunityRecommendInfo() {
      this.editCommunityRecommendInfo = {
        crId: '',
        communityName: '',
        shopName: '',
        recommendType: '',
        logo: '',
        prodName: '',
        price: '',
        url: ''
      }
    }
  }
}
</script>

<style scoped>
.el-input {
  width: 100%;
}
</style>